import { render } from "./FileItem.vue?vue&type=template&id=79406aba&scoped=true"
import script from "./FileItem.vue?vue&type=script&lang=ts"
export * from "./FileItem.vue?vue&type=script&lang=ts"

import "./FileItem.vue?vue&type=style&index=0&id=79406aba&lang=scss&scoped=true"
import "./FileItem.vue?vue&type=style&index=1&id=79406aba&lang=scss"
script.render = render
script.__scopeId = "data-v-79406aba"

export default script